module.exports = {"signalrLink":"https://ty2websocket.aliyunssl.hebeity.com","rechargeFlag":true,"bindCardFlag":true,"year":2018}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config/config.json
// module id = 183
// module chunks = 73